import { EnSortDirection } from '@shared/enums/sort-direction.enum';

export const ASSIGNMENT_LIST_SORT = {
  sortBy: 'startAt',
  sortDirection: EnSortDirection.DESC,
} as const;
